// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    CustomSubmitContactUsFormApiParameter,
    submitContactUsForm,
} from "@conklin/App/Services/ContactsUsFormService";
import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, CustomSubmitContactUsFormApiParameter>;

export const XngPopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        message: state.fieldValues["message"],
        emailTo: props.parameter.emailRecipients,
        // XNG-Changes: add custom properties
        zipCode: state.fieldValues["zipCode"],
        shipToLocationName: state.fieldValues["shipToLocationName"],
        physicalAddress: state.fieldValues["physicalAddress"],
        customerId: state.fieldValues["customerId"],
        defaultBranch: state.fieldValues["defaultBranch"],
        pickupBranch: state.fieldValues["pickupBranch"],
        deliveryLocation: state.fieldValues["deliveryLocation"],
    };
};

export const XngSendDataToApi: HandlerType = async props => {
    // XNG-Changes: custom handler
    await submitContactUsForm(props.apiParameter);
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, SendDataToApi, XngSendDataToApi);
